mutation BudgetUpdate($input: BudgetUpdateInput!) {
  budgetUpdate(input: $input) {
    clientMutationId
     budget
    {
       id
      name
      _rowTimestamp
      startingBudgetDate
      endingBudgetDate
      isPrimary
      _isUpdatable
      _isDeletable
    }
  }
}
